module.exports = __webpack_public_path__ + "static/media/logo.b2172926.png";